import type { RouteLocationNormalized } from 'vue-router';
import { useSupplementStore } from '../stores/supplementStore';
import {
  canEnterSupplementFlow,
  finalPagePath,
  isFinalPage,
  isSupplementEntryPoint,
  isSupplementFlowPage,
  isSupplementOfferPage,
  supplementOfferPath,
  toSupplementArm,
  toSupplementStage,
} from '../utils/supplement';

export default defineNuxtRouteMiddleware((to: RouteLocationNormalized, from: RouteLocationNormalized) => {
  if (import.meta.server) {
    return;
  }

  const funnelPrefix = useFunnelPrefix();
  const isFlowPage = isSupplementFlowPage(to.path, funnelPrefix);
  if (!isFlowPage && !isFinalPage(to.path, funnelPrefix)) {
    return;
  }

  const nuxtApp = useNuxtApp();
  if (!nuxtApp.$pinia) {
    return;
  }

  const store = useSupplementStore();
  const canEnter = canEnterSupplementFlow(toSupplementArm(store.arm), toSupplementStage(store.stage));

  if (isFlowPage) {
    if (!canEnter) {
      return navigateTo({ path: finalPagePath(to.path, funnelPrefix), query: to.query });
    }

    if (isSupplementOfferPage(to.path, funnelPrefix)) {
      return;
    }

    return navigateTo({ path: supplementOfferPath(to.path, funnelPrefix), query: to.query });
  }

  if (!store.arm || !canEnter || !isSupplementEntryPoint(to.path, from.path, funnelPrefix)) {
    return;
  }

  return navigateTo({ path: supplementOfferPath(to.path, funnelPrefix), query: to.query });
});
